'use client';

import { AUTH_CONFIG } from '@/config/auth.config';
import { AuthService } from '@pw-tech/web-sdk';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';

interface PWWebSDKProviderProps {
  children: React.ReactNode;
}

// Extend Window interface for PW Web SDK
// declare global {
//   interface Window {
//     PWWebSDK?: {
//       updateConfig: (config: any) => void
//     }
//     JSBridge?: {
//       goToPreviousPageInWebview: () => void
//     }
//   }
// }

export const PWWebSDKProvider: React.FC<PWWebSDKProviderProps> = ({ children }) => {
  const router = useRouter();
  const [isSDKReady, setIsSDKReady] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    // Initialize PW Web SDK
    const initializeSDK = async () => {
      try {
        // Initialize Auth Service
        AuthService.getInstance(AUTH_CONFIG as any);

        // Set up global PW Web SDK instance
        if (typeof window !== 'undefined') {
          // Initialize PW Web SDK
          if (window.PWWebSDK) {
            window.PWWebSDK.updateConfig(AUTH_CONFIG as any);
          }

          // Set up JSBridge for webview communication
          if ((window as any).JSBridge) {
            (window as any).JSBridge.goToPreviousPageInWebview = () => {
              // Handle webview navigation
              if (router) {
                router.back();
              }
            };
          }
        }

        setIsSDKReady(true);
        console.log('PW Web SDK initialized successfully');
      } catch (error) {
        console.error('Failed to initialize PW Web SDK:', error);
        // Continue without SDK if initialization fails
        setIsSDKReady(true);
      }
    };

    // Initialize when component mounts
    initializeSDK();
  }, [router]);

  useEffect(() => {
    // Set up page show handler for webview
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && router) {
        router.refresh();
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, [router]);

  // Show loading state while SDK initializes (only after mount to avoid hydration mismatch)
  if (!isSDKReady && isMounted) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-2 text-sm text-gray-600">Initializing...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};;
